import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';

import type { MenuOption } from '@swf/components/Inputs/components/Menu/Menu';
import Menu from '@swf/components/Inputs/components/Menu/Menu';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import useOnClickOutside from '@swf/core/hooks/useOnClickOutside';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { Dispatch } from '@swf/core/store';
import { PokerModalRoutes } from '@swf/core/types/Poker';

import {
  TXTCLI_Create_Tournament,
  TXTMOB_Create,
  TXTWCL_Create_Cash_Game
} from './CreateGameButtons.messages.json';
import styles from './CreateGameButtons.scss';
import AddIcon from './assets/plus.svg';

const options: MenuOption[] = [
  { text: <Translation {...TXTWCL_Create_Cash_Game} />, value: PokerModalRoutes.createCashGame },
  {
    text: <Translation {...TXTCLI_Create_Tournament} />,
    value: PokerModalRoutes.createTournament
  }
];

const CreateGameButtons: React.FC = () => {
  const { widgetId } = useWidget();
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const { modal } = useDispatch<Dispatch>();
  useOnClickOutside(triggerRef, () => {
    setIsOpen(false);
  });

  const handleSelect = ({ value }: MenuOption) => {
    setIsOpen(false);
    modal.enqueue({
      path: `${value}`,
      locationState: { clubId: Number(clubId), widgetId }
    });
  };

  return (
    <div className={styles.container} ref={triggerRef}>
      <StarsButton
        onClick={() => setIsOpen(!isOpen)}
        translation={TXTMOB_Create}
        icon={<AddIcon className={styles.icon} width="13" height="13" />}
      />
      {isOpen && <Menu className={styles.menu} onSelect={handleSelect} options={options} />}
    </div>
  );
};

export default CreateGameButtons;
